import { Injector } from '@angular/core';
import { AppConfigService } from './app-config.service';

export function loadCoreDependencies(appConfigService: AppConfigService, injector: Injector): () => Promise<void> {
  return () =>
    new Promise((resolve, reject) => {
      appConfigService
        .loadConfiguration()
        .then(() => resolve())
        .catch((error: any) => {
          // TODO: resolve and show static page in current app ex. not available
          throw Error('Config file not loaded! ' + error);
        });
    });
}
